import { create } from 'zustand';
import type { ImpactMode } from './types';

interface ExperienceState {
  impactMode: ImpactMode;
  reducedMotion: boolean;
  reducedParticles: boolean;
  paused: boolean;
  highContrast: boolean;
  commandOpen: boolean;
  setImpactMode: (mode: ImpactMode) => void;
  toggleMotion: () => void;
  toggleParticles: () => void;
  togglePaused: () => void;
  toggleContrast: () => void;
  setCommandOpen: (open: boolean) => void;
}

export const useExperienceStore = create<ExperienceState>((set) => ({
  impactMode: 'impacto',
  reducedMotion:
    typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  reducedParticles: false,
  paused: false,
  highContrast: false,
  commandOpen: false,
  setImpactMode: (impactMode) => set({ impactMode }),
  toggleMotion: () => set((state) => ({ reducedMotion: !state.reducedMotion })),
  toggleParticles: () => set((state) => ({ reducedParticles: !state.reducedParticles })),
  togglePaused: () => set((state) => ({ paused: !state.paused })),
  toggleContrast: () => set((state) => ({ highContrast: !state.highContrast })),
  setCommandOpen: (commandOpen) => set({ commandOpen }),
}));
